import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { Redirect } from 'react-router-dom';

function ComingSoon({ match }) {
    let history = useHistory();
    useEffect(() => {
    }, []);

    return (
        <>
            <Helmet link={
                [{ "rel": "stylesheet", "href": '/css/faq.css' }]
            } />
            <div className="row no-gutters">
                <div className="application">
                    <div className="appHeader bg-transparent text-light position-relative">
                        <div className="left">
                            {/* <a className="headerButton goBack"  onClick={() => history.goBack()}>
						<img src={require("./../images/faq-icon.png").default} alt="back" className="img-fluid" />
					</a> */}
                        </div>
                    </div>
                    <div className="pageTitleNew">
                        <div>
                            <img
                                src={require("./../images/left-arrow-black.png").default}
                                className="img-fluid backIcon"
                                onClick={() => history.go(-2)}
                                style={{
                                    width: "22px",
                                    cursor: "pointer",
                                    position: "absolute",
                                    left: "5px"
                                }}
                            />
                            Coming Soon...
                        </div>
                    </div>
                    <div className='bg-coming-soon'>&nbsp;</div>
                </div>
                <div className="bg"></div>
            </div>
        </>
    );
}

export default ComingSoon;
